import TenantResourceModel from '../../generated/types/model/resource/TenantResourceModel';

export default class TenantResourceViewModel extends TenantResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
